// removed by extract-text-webpack-plugin
module.exports = {"binary_iframe_spinner":"_3iam1XKPaqzvqx5y2kgXn9","binary_iframe":"_3Dva3llGdyBYQKNLrEvfWb"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryIframe/BinaryIframe.scss
// module id = 2155
// module chunks = 1